import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupTelegram } from './lib/telegram';
import { bootstrap } from './lib/sync';
import { hasToken } from './lib/api';
import { UI } from './i18n';
import { App } from './App';
import './styles/app.css';

setupTelegram();
document.documentElement.lang = UI;

// Server holati (lexo-api) → store. Token bor bo'lsa API 6 s ichida javob bermasa localStorage holati bilan davom etadi;
// token yo'q bo'lsa (birinchi kirish) login natijasi kutiladi — sessiyasiz App Gate ekranini ko'rsatadi.
const ready = Promise.race([bootstrap(), new Promise<void>((r) => setTimeout(r, hasToken() ? 6000 : 15000))]);
ready.finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
